import React from 'react'
import { Link, Text, WarningBanner as HedwigWarningBanner } from '@postenbring/hedwig-react'

export const WarningBanner = ({ title, message, href, linkText, target }) => {
    const hasMessage = Boolean(message)
    const hasLink = Boolean(href)

    return (
        <HedwigWarningBanner
            title={title}
            description={
                hasMessage || hasLink ? (
                    <>
                        {hasMessage && <span>{message}</span>}
                        {hasLink && (
                            <Link
                                variant="solid"
                                href={href}
                                target={target}
                                rel={target === '_blank' ? 'noopener noreferrer' : undefined}
                                style={{ display: 'block' }}
                                className="hds-mt-8-12"
                            >
                                <Text as="span" variant="body-small">{linkText}</Text>
                            </Link>
                        )}
                    </>
                ) : null
            }
        />
    )
}
